import styled from "styled-components/macro";

export const StyledScheduledTestRequestPage = styled.div`
  width: 100%;
  min-height: calc(100vh - 12rem);
  padding: 0 2rem;
`;

export const StyledLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
